import {Component, inject} from '@angular/core';
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {PalletType, StorageType, StorageUnitGridViewDto, StorageUnitStatus} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {Router, RouterLink} from "@angular/router";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import {PalletTypePipe} from "../../../pipes/pallet-type.pipe";

@Component({
    selector: 'app-storage-units',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent,
        CapitalCasePipe,
        RouterLink,
    ],
    providers: [PalletTypePipe],
    templateUrl: './storage-units.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 100px);
        }`
    ]
})
export class StorageUnitsComponent extends GridPageComponent<StorageUnitGridViewDto> {
    private router = inject(Router);
    private palletTypePipe = inject(PalletTypePipe);

    constructor() {
        super();
        this.init(StorageUnitGridViewDto);
    }

    dataSource = this.dataSources.storageUnits();
    statusOptions = EnumUtils.getEnumOptions(StorageUnitStatus);
    palletTypeOptions = EnumUtils.getEnumOptions(PalletType, (v) => this.palletTypePipe.transform(v));
    binTypeOptions = EnumUtils.getEnumOptions(StorageType);

    protected override exportName: string = "StorageUnits";

    protected override filterConfig: FilterConfig[] = [
        {field: 'number', op: 'contains'},
        {field: 'storageTypeCode', op: 'contains'},
        {field: 'status', op: '='},
        {field: 'batch', op: 'contains'},
        {field: 'sledBbd', op: '>='},
        {field: 'lastModified', op: '>='},
        {field: 'weight', op: '>='},
        {field: 'totalQuantityWmUoM', op: '>='},
        {field: 'wmUnit', op: 'contains'},
        {field: 'numberOfQuants', op: '>='},
        {field: 'duration', op: '>='},
        {field: 'shipmentNumber', op: 'contains'},
        {field: 'storageUnitType', op: 'contains'},
        {field: 'binNumber', op: 'contains'},
        {field: 'palletType', op: '='},
        {field: 'materialNumber', op: 'contains'},
        {field: 'materialDescription', op: 'contains'},
        {field: 'materialStorageType', op: '='},
        {field: 'rangeBrandDescription', op: 'contains'},
        {field: 'category', op: 'contains'},
        {field: 'casesPerPallet', op: '='},
        {field: 'storageType', op: '='},
        {field: 'storageBinType', op: 'contains'},
        {field: 'zone', op: 'contains'},
        {field: 'maxPallets', op: '>='},
        {field: 'aisle', op: 'contains'}
    ];

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;
        await this.router.navigate([`/inventory/storage-units/details/${data.number}`]);
    }

    protected getStatusBadgeClass(status: StorageUnitStatus): string {
        return EnumUtils.getStorageUnitStatusBadgeClass(status);
    }

    protected formatMaterialList(value: any[]): string {
        return value.filter(v => v).join(', ');
    }

    protected formatMaterialListText = (cellInfo: { value: any; valueText?: string }): string => {
        if (Array.isArray(cellInfo.value)) return this.formatMaterialList(cellInfo.value);
        return cellInfo.valueText ?? (cellInfo.value ?? '');
    };
}
